module.exports = "<div ng-if=\"!vm.isRequestFailure\" ng-class=\"{'table-grid-modal__has-data' : vm.hasData}\" ng-click=\"vm.showModal()\">{{vm.getModalLinkText()}}\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/tableGridModalLinkCell/tableGridModalLinkCell.html
// module id = 515
// module chunks = 1